export default __webpack_public_path__ + "static/Quickinstallation_IN-6001_03-8b0c0cbb5cffc581ceb1ce9983a2a8be.webp";